import React, { useEffect } from 'react';
import { Grid, Box, Typography, Divider, Skeleton } from '@mui/material';
import { DownArrow, GreenUpArrowIcon } from '../../../../assets';
import { useSelector } from 'react-redux';
import { getDifferenceBetweenDateRange } from '../../../../utility';
import { pushComponentView } from '../../../../utility/gtm';

const DigitalEngagementInfo = () => {
    const { engagementTotal, periodChange, isPeriodChangeIncrease, isLoading } =
        useSelector((state) => state.digitalEngagement);

    const { startDateRange, endDateRange } = useSelector(
        (state) => state.filter,
    );

    const { company } = useSelector((state) => state.company);

    const titles = {
        97: 'Digital Engagement',
        default: 'Digital Physician Engagement',
    };

    const title = titles[company.id] || titles['default'];

    useEffect(() => {
        pushComponentView('DigitalEngagementInfo');
    }, []);

    return (
        <>
            <Grid container>
                <Grid item xs={6}>
                    <Box className="flex-column gap-8">
                        <Box>
                            <Typography className="engagement-title">
                                {title}
                            </Typography>
                        </Box>
                        <Box className="flex-row">
                            <Box>
                                {isLoading ? (
                                    <Skeleton
                                        height={30}
                                        variant="text"
                                        width={60}
                                    />
                                ) : (
                                    <Typography className="engagement-value">
                                        {engagementTotal}
                                    </Typography>
                                )}
                            </Box>
                            <Box className="flex-column gap-2 center-align ml-5-percent">
                                <Typography
                                    className={`text-sm-medium ${isPeriodChangeIncrease ? 'success-700' : 'error-700'}`}
                                >
                                    {isLoading ? (
                                        <Skeleton variant="text" width={100} />
                                    ) : (
                                        <>
                                            {isPeriodChangeIncrease ? (
                                                <GreenUpArrowIcon />
                                            ) : (
                                                <DownArrow />
                                            )}
                                            {periodChange}
                                        </>
                                    )}
                                </Typography>
                                <Typography className="physicians-engagement-last-year">
                                    vs Last{' '}
                                    {getDifferenceBetweenDateRange(
                                        startDateRange,
                                        endDateRange,
                                    )}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>

            <Divider className="mv-24 border-1-gray" />
        </>
    );
};

export default DigitalEngagementInfo;
